import React, { useState, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { MyContext, ListContext } from "./MyContext";
import { BlockLabelGrow, BlockLabel } from "./styleCustom";
// import AuthHelperMethods from "./AuthHelperMethods";
import { Row, Modal } from "react-bootstrap";
import { dateObjToDBDate, stringToDateObj } from "./momentUtils";
import COLORS, { buttonOrangeStyle, buttonBlueStyle } from "./styleConstants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DATEPICKER_DATE_DISPLAY } from "./UserSettings";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ModalHeaderBlue } from "./formComponents";
import AlertModal, { useAlertModal } from "./AlertModal";
import { ERROR_MESSAGES } from "./errorMessages";
import { useManualPayment } from "./createPaymentAndItems";

import Auth from "./Auth";

const ManualPurchase = (props) => {
  const [showSavedCardOption, setShowSavedCardOption] = useState(false);
  const [pDate, setPdate] = useState();

  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch, setGlobalError } = useContext(MyContext);
  let location = useLocation();
  const calendar = location.pathname.startsWith("/admin/calendarGroup/edit");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [offlineLocked, setOfflineLocked] = useState(false);
  const { modalConfig, showError, showAlert, hideAlert } = useAlertModal();
  const [showModal, setShowModal] = useState(true);
  const [paymentOrInvoice, setPaymentOrInvoice] = useState(
    props.thisisinvoice ? "Invoice" : "Payment",
  );
  // const accountInfo, setAccountInfo=useState()
  //const [noShow, setNoShow] = useState(false);
  //const [n, setN] = useState();
  // const [showDunno, setShowDunno] = useState(false);

  let history = useHistory();

  useEffect(
    () => {
      let data = {};
      data.fee = 0;
      dispatch2(["REMOVE_CART_FEE"]);
    },
    //eslint-disable-next-line
    [],
  );

  useEffect(() => {
    return () => {
      dispatch2(["SET_QUICKPAY_STUDENT_ID", ""]);
    };
  }, []);

  useEffect(() => {
    if (!mystate.isFetching) {
      setButtonDisabled(false);
    }
  }, [mystate.isFetching]);

  useEffect(() => {
    const handleOnline = () => setOfflineLocked(false);
    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, []);

  async function checkIfClientHasPaymentMethod(student_id) {
    if (!student_id) return;

    dispatch({
      type: "FETCH_INIT",
    });

    if (!mystate.currentStudent.student_id) return false;
    const params = { student_id: mystate.currentStudent.student_id };
    const result = await Auth.api(
      "payments/checkIfClientHasASingleOrDefaultPaymentMethod",
      "get",
      params,
    );
    console.dir(result.data);
    dispatch({
      type: "FETCH_SUCCESS",
    });
    return result.data.stripe_payment_method_id;
  }

  useEffect(() => {
    if (calendar)
      checkIfClientHasPaymentMethod(listState.quickpaystudentid).then(
        (result) => setShowSavedCardOption(result),
      );
  }, []);

  const finishPay = (itemIds) => {
    if (listState.quickpaystudentid) {
      dispatch({
        type: "UPDATE_QUICKPAY",
        student_id: listState.quickpaystudentid,
        item_id: itemIds[0],
      });
    }
    setShowModal(false);
    const closeSuccess = () => {
      hideAlert();
      history.goBack();
    };
    showAlert({
      title: `${paymentOrInvoice} Saved`,
      message: props.thisisinvoice
        ? "Your invoice was created successfully."
        : "Your payment was recorded successfully.",
      type: "success",
      onClose: closeSuccess,
      buttons: [{ text: "OK", onClick: closeSuccess, variant: "primary" }],
    });
  };

  const cancelPayment = () => {
    dispatch2(["SET_QUICKPAY_STUDENT_ID", ""]);
    history.goBack();
  };

  const { submitPayment, processing } = useManualPayment({
    onFinish: finishPay,
    onError: showError,
  });
  return (
    <>
      <AlertModal {...modalConfig} />
      <Modal show={showModal}>
        <ModalHeaderBlue>
          <Modal.Title>{`${paymentOrInvoice} Note`}</Modal.Title>
        </ModalHeaderBlue>
        <Modal.Body>
          <Formik
            initialValues={{
              method: "cash",
              reference: "",
              notes: "",
              amount: listState.cartTotal,
            }}
            validationSchema={Yup.object({})}
            onSubmit={async (values, { setSubmitting }) => {
              if (offlineLocked) return;
              if (!navigator.onLine) {
                setOfflineLocked(true);
                setGlobalError({ message: ERROR_MESSAGES.OFFLINE_POST, persist: true, showButtons: false, source: "post" });
                setSubmitting(false);
                return;
              }
              setButtonDisabled(true);
              try {
                await submitPayment({
                  transaction_type: props.thisisinvoice ? "invoice" : values.method,
                  payment_notes: values.notes,
                  reference: values.reference,
                  purchase_date: pDate,
                });
              } finally {
                setSubmitting(false);
                setButtonDisabled(false);
              }
            }}
          >
            <Form id="manualPurchaseForm">
              <Row style={{ fontSize: 20, color: COLORS.blue, justifyContent: "center", marginBottom: 10 }}>
                {`${paymentOrInvoice} ${mystate.farmDefaults.currency_code} ${listState.cartSubtotalWithTax}`}
              </Row>
              <Row style={{ justifyContent: "center" }}>
                <div
                  style={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <BlockLabel>{"Purchase Date"}</BlockLabel>
                  <DatePicker
                    name="purchasedate"
                    dateFormat={DATEPICKER_DATE_DISPLAY}
                    selected={stringToDateObj(
                      listState.currentProduct.purchase_date,
                    )}
                    onChange={(date) => {
                      if (!date) console.log("yuck");
                      else {
                        setPdate(dateObjToDBDate(date));

                        dispatch2([
                          "SET_CURRENT_PRODUCT",
                          {
                            ...listState.currentProduct,
                            purchase_date: dateObjToDBDate(date),
                          },
                        ]);
                      }
                    }}
                  />{" "}
                </div>
              </Row>
              {!props.thisisinvoice && (
                <Row>
                  <BlockLabelGrow>Method</BlockLabelGrow>
                  <div
                    role="group"
                    aria-labelledby="my-radio-group"
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      flex: "1 1 100%",
                      padding: 10,
                      fontSize: 12,
                    }}
                  >
                    <label>
                      <Field
                        style={{ marginRight: 5 }}
                        type="radio"
                        name="method"
                        value="cash"
                      />
                      Cash
                    </label>
                    <label>
                      <Field
                        style={{ marginRight: 5 }}
                        type="radio"
                        name="method"
                        value="cheque"
                      />
                      Check
                    </label>
                    <label>
                      <Field
                        style={{ marginRight: 5 }}
                        type="radio"
                        name="method"
                        value="venmo"
                      />
                      Venmo
                    </label>
                    <label>
                      <Field
                        style={{ marginRight: 5 }}
                        type="radio"
                        name="method"
                        value="transfer"
                      />
                      Bank Transfer
                    </label>
                    <label>
                      <Field
                        style={{ marginRight: 5 }}
                        type="radio"
                        name="method"
                        value="other"
                      />
                      Other
                    </label>
                    {showSavedCardOption && (
                      <label>
                        <Field
                          style={{ marginRight: 5 }}
                          type="radio"
                          name="method"
                          value="saved"
                        />
                        Saved Card
                      </label>
                    )}
                  </div>
                </Row>
              )}
              <Row style={{ justifyContent: "center" }}>
                <div
                  style={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <BlockLabel>{"Reference"}</BlockLabel>
                  <Field
                    as="input"
                    type="string"
                    name="reference"
                    placeholder={`${paymentOrInvoice} reference`}
                  />
                </div>
              </Row>
              <Row style={{ justifyContent: "center" }}>
                <div
                  style={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <BlockLabel>{"Notes"}</BlockLabel>
                  <Field as="textarea" name="notes" rows={4} />
                </div>
              </Row>
            </Form>
          </Formik>
        </Modal.Body>

        <Modal.Footer>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: "1 1 100%",
            }}
          >
            <button style={buttonBlueStyle} onClick={() => cancelPayment()}>
              {"Cancel"}
            </button>

            <div>
              <button
                disabled={buttonDisabled || processing || offlineLocked}
                style={{
                  ...buttonOrangeStyle,
                  background: buttonDisabled || processing || offlineLocked ? "grey" : COLORS.orange,
                }}
                form="manualPurchaseForm"
                type="submit"
              >
                {`Save ${paymentOrInvoice}`}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ManualPurchase;
